import React, { useState, useCallback, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Button } from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { errorMessage$, successMessage$ } from "../../../utils/subjects";
import api from "../../../services/api";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function DialogCurrency({
  handleClose,
  handleOpen,
  open,
  callback,
  id,
}) {
  const classes = useStyles();

  const [currencyId] = useState(id);
  const [name, setName] = useState('');
  const [abbreviation, setAbbreviation] = useState('');

  useEffect(() => {
    api.get(`master/currencies/${currencyId}`).then(response => {
      setName(response.data.Name);
      setAbbreviation(response.data.Abbreviation);
    }).catch(err => {
      errorMessage$.next({
        open: true,
        message: "Error on load currency",
      });
    });
  }, [currencyId]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();

    try {
      const data = {
        Name: name,
        Abbreviation: abbreviation,
      };

      handleClose();
      await api.put(`master/currencies/${currencyId}`, data);

      successMessage$.next({
        open: true,
        message: "Currency updated successfully",
      });
      if (callback) callback();
    } catch (err) {
      errorMessage$.next({
        open: true,
        message: "Error on update currency",
      });
    }
  }, [abbreviation, callback, currencyId, handleClose, name]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      style={{ minWidth: 200 }}
    >
      <DialogTitle id="form-dialog-title">Edit currency</DialogTitle>
      <form className={classes.root} onSubmit={handleSubmit}>
        <DialogContent style={{ minWidth: 400 }}>
          <TextField
            fullWidth
            label="Currency (ISO)"
            id="currency-name"
            value={name}
            required={true}
            onChange={e => setName(e.target.value)}
            style={{ marginBottom: 24 }}
          />
          <TextField
            fullWidth
            label="Abbreviation"
            id="currency-abbreviation"
            value={abbreviation}
            required={true}
            onChange={e => setAbbreviation(e.target.value)}
            style={{ marginBottom: 24 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            Cancel
          </Button>
          <Button color="primary" type="submit">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
